module.exports = __webpack_public_path__ + "img/xsort.80a75c64.svg";